export const mimeType = [
  'application/pdf', //.pdf and .ai
  'text/plain', //.txt
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //.docx
  'application/msword', //.doc
  'application/rtf', //.rtf
  'text/csv', //.csv
  'application/vnd.ms-excel', //.xls
  'application/zip', //.zip
  'image/jpeg', //.jpg .jpeg
  'image/tiff', //.tiff
  'image/png', //.png
  'image/gif', //.gif
  'image/bmp', //.bmp
  'image/svg+xml', //.svg
  'image/vnd.adobe.photoshop', //.psd TODO double check this one
  'image/vnd.microsoft.icon', //.ico
  'audio/wav', //.wav
  'audio/mpeg', //.mp3
  'audio/flac', //.flac TODO double check this one
  'video/mp4', //.mp4
  'video/quicktime', //.mov
] as const

export type MimeType = (typeof mimeType)[number]
